import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND } from "../lib/data";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="site-navbar">
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" className="flex items-center min-w-0" data-testid="navbar-logo">
          <img
            src={BRAND.logo}
            alt={BRAND.logoAlt}
            className="h-11 md:h-14 w-auto object-contain shrink-0"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-brandred" : "text-navy hover:text-brandred"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contact#lead"
            className="hidden lg:inline-flex items-center bg-brandred hover:bg-brandred-700 text-white px-5 py-2.5 text-sm font-semibold rounded-sm transition-colors"
            data-testid="navbar-apply-cta"
          >
            Apply for Funding
          </Link>
          <button
            className="lg:hidden text-navy"
            onClick={() => setOpen(!open)}
            data-testid="navbar-mobile-toggle"
            aria-label="Toggle menu"
            aria-expanded={open}
            aria-controls="mobile-menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div id="mobile-menu" className="lg:hidden border-t border-border bg-white" data-testid="mobile-menu">
          <div className="container-x py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className="text-navy font-medium py-2"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact#lead"
              onClick={() => setOpen(false)}
              className="bg-brandred text-white text-center py-2.5 rounded-sm font-semibold"
              data-testid="mobile-apply-cta"
            >
              Apply for Funding
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
